import { Typography } from "@kyan/ui";

import { type EstimatedExecPriceProps } from "#/types/fees";
import { formatValue } from "#/utils/valueFormatters";

import { useEstimatedExecPriceController } from "./EstimatedExecPrice.controller";

export const EstimatedExecPrice: React.FC<EstimatedExecPriceProps> = (
  props,
) => {
  const { executionPrice, hasEnoughLiquidity } =
    useEstimatedExecPriceController(props);

  return (
    <div className="flex justify-between">
      <Typography grotesk size={12}>
        Estimated execution price
      </Typography>

      <div className="flex gap-1">
        <Typography grotesk primary size={12}>
          {hasEnoughLiquidity ? formatValue(executionPrice) : ""}
        </Typography>
        <Typography grotesk size={12}>
          {hasEnoughLiquidity ? "USD" : "-"}
        </Typography>
      </div>
    </div>
  );
};
